import eventHub from '@/scripts/eventHub';
import gsap from 'gsap';
import {
  Sprite,
  Loader,
  TilingSprite,
  Texture,
  WRAP_MODES,
  BLEND_MODES,
} from 'pixi.js';
import state from '../state';
import ticker from '../ticker';
import vars from '../vars';

class BackgroundStage {
  constructor(parent) {
    this.parent = parent;
    this.tileDirection = true;

    this.ref = new Sprite();

    const wallTexture = new Texture(Loader.shared.resources['textures/WALL'].texture);
    const skyTexture = new Texture(Loader.shared.resources['textures/SKY'].texture);
    wallTexture.baseTexture.wrapMode = WRAP_MODES.REPEAT;
    skyTexture.baseTexture.wrapMode = WRAP_MODES.REPEAT;

    this.wall = new TilingSprite(wallTexture, vars.layout.FRAME_WIDTH, wallTexture.orig.height);
    this.wall.blendMode = BLEND_MODES.MULTIPLY;
    this.sky = new TilingSprite(skyTexture, vars.layout.FRAME_WIDTH, wallTexture.orig.height);
    this.sky.tilePosition.y = -vars.layout.FRAME_HEIGHT;

    this.skyOverlay = new TilingSprite(skyTexture, vars.layout.FRAME_WIDTH, wallTexture.orig.height);
    this.skyOverlay.zIndex = 3;
    this.skyOverlay.alpha = 0.3;
    this.skyOverlay.blendMode = BLEND_MODES.MULTIPLY;
    this.skyOverlay.tilePosition.y = -vars.layout.FRAME_HEIGHT;

    const groundTexture = new Texture(Loader.shared.resources['textures/GRASS'].texture);
    groundTexture.baseTexture.wrapMode = WRAP_MODES.REPEAT;
    this.ground = new TilingSprite(groundTexture, vars.layout.FRAME_WIDTH, 300);

    this.ref.addChild(this.sky);
    this.ref.addChild(this.wall);
    this.ref.addChild(this.ground);
    this.resize();

    this.frameHandler = () => { this.frame(); };
    this.levelChangeHandler = () => { this.levelChange(); };

    eventHub.$on('levelchange', () => { this.levelChangeHandler(); });

    this.parent.addChild(this.ref);
    this.parent.addChild(this.skyOverlay);
  }

  resize() {
    this.ground.position.y = vars.layout.FRAME_HEIGHT - this.ground.height + 100;
  }

  startMove() {
    ticker.add(this.frameHandler);
  }

  frame() {
    this.wall.tilePosition.x -= state.backgroundSpeed * ticker.speed;
    this.ground.tilePosition.x -= state.foregroundSpeed * ticker.speed;
  }

  levelChange() {
    gsap.to([this.sky.tilePosition, this.skyOverlay.tilePosition], {
      y: `${this.tileDirection ? '+' : '-'}=${vars.layout.FRAME_HEIGHT / 6}`,
      ease: 'power2.inOut',
      duration: 5,
    }).then(() => {
      if (
        this.sky.tilePosition.y >= -vars.layout.FRAME_HEIGHT / 6
        || this.sky.tilePosition.y <= -vars.layout.FRAME_HEIGHT
      ) {
        this.tileDirection = !this.tileDirection;
      }
    });
  }

  gameover() {
    gsap.to(this.ground, {
      y: `+=${this.ground.height}`,
      duration: 0.8,
      ease: 'back.in(1.7)',
    }).then(() => {
      this.ground.renderable = false;
    });
  }

  replay() {
    this.ground.renderable = true;
    gsap.to(this.ground, {
      y: vars.layout.FRAME_HEIGHT - this.ground.height + 100,
      duration: 0.8,
      ease: 'back.out(1.7)',
    });
  }
}

export default BackgroundStage;
